import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 72,
	height: 60,
	fill: "none",
	viewBox: "0 0 72 60",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 34.1,
			cy: 40.9,
			r: 19.1,
			fill: "#EDF1F8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 33.2,
			cy: 39.9,
			r: 18.2,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 34.5,
			cy: 25.8,
			r: 12.4,
			fill: "#EDF1F8"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 33.5,
			cy: 25.8,
			fill: "#fff",
			rx: 11.5,
			ry: 11.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 34.8,
			cy: 12.8,
			r: 8.3,
			fill: "#EDF1F8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 33.8,
			cy: 13.1,
			r: 8,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 33.5,
			cy: 26.2,
			r: .6,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 33.5,
			cy: 32.6,
			r: .6,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 33.5,
			cy: 47.2,
			r: .6,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 33.5,
			cy: 40.9,
			r: .6,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 33.5,
			cy: 53,
			r: .6,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 31.3,
			cy: 11.2,
			r: 1,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 33.2,
			cy: 18.2,
			r: .3,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 34.5,
			cy: 18.2,
			r: .3,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 35.7,
			cy: 17.6,
			r: .3,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 31.9,
			cy: 17.6,
			r: .3,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 36.4,
			cy: 11.2,
			r: 1,
			fill: "#031839"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FDC564",
			d: "M28.7 14.2s1.9-.8 3.1-.8c1.1 0 2.7.4 2.7.4s.3.4.3.8c0 .3-.3.7-.3.7h-5.8s-.4-.4-.3-.7c0-.2.3-.4.3-.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M27.8 5.1s4.2-2 7-2c2.7 0 7 2 7 2s.6.6.6 1.3c0 .7-1.2 1.3-1.2 1.3s-3.7-2-6.4-2c-2.8 0-6.4 2-6.4 2s-1.3-.6-1.3-1.3c0-.7.7-1.3.7-1.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M30.3 2.7c0-1 .7-2 1.8-2.3.8-.2 1.9-.4 2.7-.4.8 0 1.8.2 2.7.4 1 .3 1.8 1.2 1.8 2.3v.5c0 .7-.6 1.3-1.3 1.3h-6.4c-.7 0-1.3-.6-1.3-1.3v-.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EDF1F8",
			d: "M20.5 52.4c-6-.6-9.7-1-15 2.6C3.1 56.5 0 60 0 60h72s-17.9-3.1-21.6-3.9c-5.8-1.1-9.2 2.7-15 2-6-.8-9-5.1-15-5.7Z"
		})
	]
});
const SvgSnowman = styled(base)({});
export default SvgSnowman;
